import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'i-frame',
  styleUrls: ['./i-frame.component.scss'],
  template: `
    @if (url) {
      <iframe #iframe [ngClass]="{'frame-sm': small, 'frame-absolute': absolute}" [src]="url"
              [sandbox]="sandbox"></iframe>
    }
    @if (html) {
      <iframe #iframe [ngClass]="{'frame-sm': small, 'frame-absolute': absolute}"
              [srcdoc]="html | safe: 'html'" [sandbox]="sandbox"></iframe>
    }`
  // TODO REFACTOR
  ,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
// TODO remove or fix sandbox-binding
export class IFrameComponent implements AfterViewInit, OnChanges {

  @Input() public url?: string;
  @Input() public html?: string;
  @Input() public frameHeight?: string;
  @Input() public small?: boolean;
  @Input() public absolute?: boolean;
  @Input() public sandbox?: string = 'allow-presentation allow-same-origin allow-scripts';

  @ViewChild('iframe', { static: true }) private iframe?: ElementRef;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public ngOnChanges(changes: SimpleChanges): void {
    this.ngAfterViewInit();
  }


  public ngAfterViewInit(): void {
    if (!this.iframe) {
      return;
    }
    const frame = this.iframe.nativeElement as HTMLIFrameElement;
    frame.height = this.frameHeight ?? '';

    if (this.sandbox) {
      (frame.sandbox as any) = this.sandbox;
    }
  }
}
